import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ConfirmationModalComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [ConfirmationModalComponent],
  entryComponents: [ConfirmationModalComponent],
})
export class ConfirmationModalModule {}
